export default "__VITE_PUBLIC_ASSET__369e3318__"